import { styled } from "goober";
import type { ReactNode } from "react";
import { Text } from "../Text";
import { MONITORING_PANEL_PADDING } from "./monitoringPanelLayout";

export const InfoCorner = styled("div")`
  position: absolute;
  top: ${MONITORING_PANEL_PADDING}px;
  right: ${MONITORING_PANEL_PADDING}px;
  z-index: 1;
`;

const Pill = styled("span")`
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 38px;
  background: var(--alpha4);
  color: var(--text-secondary);
`;

export function PanelBadge({ children }: { children: ReactNode }) {
  return (
    <Pill>
      <Text variant="text-small-md">{children}</Text>
    </Pill>
  );
}
